<!-- This component has been deprecated since it lacks necessary accessibility features. -->
<!-- Prefer using base-input-v2.vue or base-textarea.vue instead. -->

<template>
  <div :class="['input', readonlyClass, hasErrorsClass]">
    <label
      v-if="labelText"
      v-epi-edit="epiEdit"
      v-tooltip.top="tooltip"
      :for="id"
      class="input__label indicate-tooltip">{{ labelText }}</label>

    <div :class="['input__container', { 'input__container--has-prefix-value': prefixValue }]">
      <div v-if="prefixValue" class="input__prefix-value">
        {{ prefixValue }}
      </div>

      <div v-if="useIconPrepend" class="base-input__icon base-input__icon--prepend">
        <slot name="iconPrepend"></slot>
      </div>

      <textarea
        v-if="textarea"
        ref="input"
        :value="value"
        :maxlength="maxLength"
        v-bind="$attrs"
        :class="['input__textarea', { 'input__element--is-gray': useGrayInput }]"
        @input="changeValue($event.target.value)"
        @blur="handleBlur($event.target.value)"></textarea>

      <input
        v-else-if="mask"
        :id="id"
        :key="id + mask"
        ref="input"
        v-mask="mask"
        :name="id"
        :maxlength="maxLength"
        :class="['input', 'input__element', 'input__element--mask', { 'input__element--use-icon-prepend': useIconPrepend }, { 'input__element--use-icon-append': useIconAppend }, { 'input__element--is-gray': useGrayInput }]"
        :value="value"
        :readonly="isReadonly"
        v-bind="$attrs"
        @input="changeValue($event.target.value)"
        @blur="handleBlur($event.target.value)"
        @focus="$emit('focus')"
        @keyup="keyup"
        @keydown="keydown">

      <input
        v-else
        :id="id"
        :key="id + mask"
        ref="input"
        :name="$attrs.name || id"
        :maxlength="maxLength"
        :class="['input', 'input__element', { 'input__element--use-icon-prepend': useIconPrepend }, { 'input__element--use-icon-append': useIconAppend }, { 'input__element--is-gray': useGrayInput }]"
        :value="value"
        :readonly="isReadonly"
        v-bind="$attrs"
        @input="changeValue($event.target.value)"
        @blur="handleBlur($event.target.value)"
        @focus="$emit('focus')"
        @keyup="keyup"
        @keydown="keydown">

      <div v-if="useIconAppend" class="base-input__icon base-input__icon--append">
        <slot name="iconAppend"></slot>
      </div>
    </div>

    <div v-if="errorMessages.length > 0 || informationMessage" class="input__message">
      <template v-for="error in errorMessages">
        <div :key="`input-error-${error}`" class="input__message--error">
          {{ error }}
        </div>
      </template>

      <div v-html="informationMessage"></div>
    </div>
  </div>
</template>

<script>
import { mask } from 'vue-the-mask'

export default {
  directives: { mask },
  props: {
    value: {
      type: [String, Number, Date],
      default: null
    },
    id: {
      type: String,
      default: ''
    },
    labelText: {
      type: String,
      default: ''
    },
    maxLength: {
      type: Number,
      default: 100
    },
    errorMessages: {
      type: Array,
      default: () => []
    },
    informationMessage: {
      type: String,
      default: ''
    },
    textarea: {
      type: Boolean,
      default: false
    },
    isReadonly: {
      type: Boolean,
      default: null
    },
    eventKey: {
      type: String,
      default: null
    },
    epiEdit: {
      type: String,
      default: null
    },
    mask: {
      type: [String, Boolean, Object],
      default: null
    },
    useGrayInput: {
      type: Boolean,
      default: false
    },
    prefixValue: {
      type: String,
      default: null
    },
    tooltip: {
      type: String,
      default: ''
    },
    autoFocus: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    useIconPrepend() {
      return !!this.$slots['iconPrepend']
    },
    useIconAppend() {
      return !!this.$slots['iconAppend']
    },
    useMask() {
      return this.mask !== null
    },
    readonlyClass() {
      return this.isReadonly ? `input--is-readonly` : null
    },
    hasErrorsClass() {
      return this.errorMessages.length > 0 ? 'input--has-errors' : null
    }
  },
  mounted() {
    if (this.autoFocus) {
      this.$nextTick(function() {
        this.$refs.input.focus()
      })
    }
  },
  methods: {
    changeValue(value) {
      if(this.eventKey) {
        this.publish(this.eventKey, value)
      }
      this.$emit('input', value)
    },
    keyup(event) {
      this.$emit('keyup', event)
    },
    keydown(event) {
      this.$emit('keydown', event)
    },
    handleBlur(value) {
      this.$emit('blur')
      this.changeValue(value.trim())
    }
  }
}
</script>

<style lang="scss">
.input {
  width: 100%;
}

.input--is-readonly {
  pointer-events: none;
}

.article-search__amount.input {
  width: 9rem;
}

.input__label {
  @include body-smaller-semi-bold;
  display: inline-block;
  margin-bottom: measure(eighth);
}

.input__container {
  position: relative;
}

.input__container--has-prefix-value {
  display: flex;
}

.input__prefix-value {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 3.125rem;
  margin-right: measure(quarter);
  padding: measure(eighth) measure(half);
  background-color: color(background-gray-5);
  border: 1px solid color(border-gray);
  color: color(text-gray);
  pointer-events: none;
}

.base-input__icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
}

.base-input__icon--prepend {
  left: measure(quarter);
}

.base-input__icon--append {
  right: measure(quarter);
}

.input__element {
  display: block;
  width: 100%;
  height: 3.125rem;
  padding: 0 measure(half);
  border: 1px solid color(border-gray);
}

.input__element--is-gray {
  background-color: color(background-gray-5);
}

.cart-result__search .input__element {
  height: 2.5rem;
}

.cart-result__search-amount .input__element {
  height: 2.5rem;
  text-align: center;
}

.article-search__amount .input__element {
  text-align: center;
}

.input--has-errors .input__element {
  border-color: color(text-red);
}

.input__element[readonly] {
  opacity: .6;
}

.input__element--use-icon-prepend {
  padding: 0 measure(half) 0 2.5rem;
}

.input__element--use-icon-append {
  padding: 0 2.5rem 0 measure(half);
}

.input__textarea {
  display: block;
  width: 100%;
  height: 6rem;
  margin: 0;
  padding: measure(quarter);
  border: 1px solid color(border-gray);
  resize: none;
}

.input--has-errors .input__textarea {
  border-color: color(text-red);
}

.input__message {
  @include body-smaller;
  padding: measure(quarter) 0;
}

.input__message--error {
  color: color(text-red);
}
</style>
